import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

import { AuthPlugin } from "@canvas/authplugin";
import { HttpPlugin } from "@canvas/api";
import { ComponentsPlugin } from "@canvas/componentlibrary";
import { loadPlugins } from "@canvas/analyticsplugin";
import "@canvas/componentlibrary/dist/primitive-components.css";

Vue.use(ComponentsPlugin);

Vue.config.productionTip = false;

fetch("/config.json")
  .then(response => response.json())
  .then(config => {
    store.commit("appModule/config", config);
    let auth = AuthPlugin.initialize(config);
    loadPlugins(config.analytics.value, config.analytics.defaultplugin).then(
      (analytics: any) => {
        store.commit("appModule/analyticsInstance", analytics);
      }
    );

    store.commit("appModule/auth", auth);
    Vue.use(HttpPlugin, { auth });

    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  });
